// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2D4A1","title":"Header_title__UapwE","side":"Header_side__xqS3t"};